/** Excel sheet (tab) names max length per XLSX / Excel spec */
export const EXCEL_SHEET_NAME_MAX_LENGTH = 31;

const INVALID_EXCEL_SHEET_NAME_CHARS = /[\\/?*[\]:]/g;

/**
 * Sanitize a string for use as an Excel worksheet tab name.
 * Strips illegal characters and truncates to the Excel 31-char limit.
 */
export const sanitizeSheetName = (name: string, fallback = 'Sheet1'): string =>
    name.replace(INVALID_EXCEL_SHEET_NAME_CHARS, '').substring(0, EXCEL_SHEET_NAME_MAX_LENGTH) || fallback;
